import { render, staticRenderFns } from "./Novedades.vue?vue&type=template&id=6a49d864&scoped=true"
import script from "./Novedades.vue?vue&type=script&lang=js"
export * from "./Novedades.vue?vue&type=script&lang=js"
import style0 from "./Novedades.vue?vue&type=style&index=0&id=6a49d864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49d864",
  null
  
)

export default component.exports